
export const group_and_criminal_score_to_months = {
    "Group 1": {
      "0 to 0.5": "360 - 720",
      "0.75 to 1.75": "360 - 720",
      "2 to 3.75": "360 - 720",
      "4 to 5.75": "360 - 720",
      "6+": "360+"
    },
    "Group 2": {
      "0 to 0.5": "144 - 288",
      "0.75 to 1.75": "156 - 300",
      "2 to 3.75": "168 - 312",
      "4 to 5.75": "180 - 324",
      "6+": "192+"
    },
    "Group 3": {
      "0 to 0.5": "90 - 180",
      "0.75 to 1.75": "102 - 192",
      "2 to 3.75": "114 - 204",
      "4 to 5.75": "126 - 216",
      "6+": "138+"
    },
    "Group 4": {
      "0 to 0.5": "48 - 120",
      "0.75 to 1.75": "60 - 132",
      "2 to 3.75": "72 - 144",
      "4 to 5.75": "84 - 156",
      "6+": "96+"
    },
    "Group 5": {
      "0 to 0.5": "36 - 84",
      "0.75 to 1.75": "48 - 96",
      "2 to 3.75": "60 - 108",
      "4 to 5.75": "72 - 120",
      "6+": "84+"
    },
    "Group 6": {
      "0 to 0.5": "18 - 60",
      "0.75 to 1.75": "24 - 66",
      "2 to 3.75": "30 - 72",
      "4 to 5.75": "36 - 78",
      "6+": "42+"
    },
    "Group 7": {
      "0 to 0.5": "12 - 36",
      "0.75 to 1.75": "18 - 42",
      "2 to 3.75": "24 - 48",
      "4 to 5.75": "30 - 54",
      "6+": "36+"
    },
    "Group 8": {
      "0 to 0.5": "6 - 24",
      "0.75 to 1.75": "10 - 28",
      "2 to 3.75": "14 - 32",
      "4 to 5.75": "18 - 36",
      "6+": "22+"
    },
    "Group 9": {
      "0 to 0.5": "1 - 12",
      "0.75 to 1.75": "3 - 16",
      "2 to 3.75": "5 - 20",
      "4 to 5.75": "7 - 24",
      "6+": "9+"
    }
  };
  export const groupToHistoryScore = {
    "Group 1": 3,
    "Group 2": 3,
    "Group 3": 3,
    "Group 4": 3,
    "Group 5": 3,
    "Group 6": 2,
    "Group 7": 2,
    "Group 8": 1,
    "Group 9": 1
  };
  
  export const offenseToSeverityGroup2 = {
    // Group 1 Offenses
    'Murder first degree with armed': 1,
    'Murder first degree': 1,
    'Murder of a law enforcement officer first degree': 1,

    // Group 2 Offenses
    'Murder second degree with armed': 2,
    'Murder second degree': 2,
    'Sexual abuse first degree': 2,
    'Child sexual abuse first degree with armed': 2,
    'Sexual abuse first degree with armed': 2,

    // Group 3 Offenses
    'Assault with intent to kill with armed': 3,
    'Burglary first degree with armed': 3,
    'Carjacking with armed': 3,
    'Child sexual abuse first degree': 3,
    'Kidnapping with armed': 3,
    'Voluntary manslaughter with armed': 3,

    // Group 4 Offenses
    'Aggravated assault with armed': 4,
    'Voluntary manslaughter': 4,
  
    // Group 5 Offenses
    'Armed robbery': 5,
    'Assault on police officer with armed (30-year statutory maximum)': 5,
    'Assault with intent to commit any offense with armed': 5,
    'Assault with intent to commit robbery with armed': 5,
    'Assault with intent to kill': 5,
    'Burglary first degree': 5,
    'Carjacking': 5,
    'Involuntary manslaughter with armed': 5,
    'Involuntary manslaughter': 5,
    'Kidnapping': 5,
    'Malicious disfigurement with armed': 5,
    'Mayhem with armed': 5,
    'Obstruction of justice': 5,
    'Possession of a firearm during a crime of violence': 5,
    'Child sexual abuse second degree with armed': 5,
    'Sexual abuse second degree with armed': 5,
    'Sexual abuse second degree': 5,
    'Assault with intent to commit first degree child sexual abuse with armed': 5,
    'Assault with intent to commit second degree child sexual abuse with armed': 5,
    'Assault with intent to commit first degree sexual abuse with armed': 5,
    'Assault with intent to commit second degree sexual abuse with armed': 5,
    'Attempted child sexual abuse first degree with armed': 5,
    'Attempted child sexual abuse second degree with armed': 5,
    'Attempted sexual abuse first degree with armed': 5,
    'Attempted sexual abuse second degree with armed': 5,

    // Group 6 Offenses
    'Aggravated assault': 6,
    'Arson': 6,
    'Former assault on police officer with a dangerous weapon': 6,
    'Assault with a dangerous weapon': 6,
    'Assault with intent to commit robbery': 6,
    'Attempted robbery with armed': 6,
    'Burglary second degree with armed': 6,
    'Cruelty to children first degree': 6,
    'Malicious disfigurement': 6,
    'Mayhem': 6,
    'Robbery': 6,
    'Assault with intent to commit first degree child sexual abuse': 6,
    'Assault with intent to commit second degree child sexual abuse': 6,
    'Assault with intent to commit first degree sexual abuse': 6,
    'Assault with intent to commit second degree sexual abuse': 6,
    'Attempted child sexual abuse first degree': 6,
    'Child sexual abuse second degree': 6,
    'Attempted sexual abuse first degree': 6,

    // Group 7 Offenses
    'Assault with intent to commit mayhem': 7,
    'Current assault on police officer (10-year statutory maximum)': 7,
    'Burglary second degree': 7,
    'Negligent homicide': 7,
    'Felon in possession of firearm (prior crime of violence, not conspiracy)': 7,
    'Attempted sexual abuse second degree': 7,
    'Sexual abuse of a patient first degree': 7,
    'Sexual abuse of a ward first degree': 7,
    'Sexual abuse third degree': 7,
    'Unauthorized Use of a Vehicle (during or to facilitate a crime of violence)': 7,

    // Group 8 Offenses
    'Assault with intent to commit any offense': 8,
    'Attempted aggravated assault': 8,
    'Assault with Significant Bodily Injury': 8,
    'Attempted burglary': 8,
    'Carrying a Pistol Without License/Carrying a Dangerous Weapon': 8,
    'Cruelty to children second degree': 8,
    'Destruction of Property (felony)': 8,
    'Extortion': 8,
    'Unlawful Possession of a Firearm (felon in possession)': 8,
    'Introducing Class A contraband into a penal institution': 8,
    'Attempted kidnapping': 8,
    'Perjury': 8,
    'Attempted robbery': 8,
    'Theft first degree': 8,
    'Threats to do bodily harm': 8,
    'Trafficking in stolen property': 8,
    'Unauthorized Use of a Vehicle': 8,
    'Attempted child sexual abuse second degree': 8,
    'Enticing a child': 8,
    'Attempted sexual abuse of a patient first degree': 8,
    'Attempted sexual abuse of a ward first degree': 8,
    'Attempted sexual abuse third degree': 8,
    'Sexual abuse fourth degree': 8,
    'Sexual abuse of a patient second degree': 8,
    'Sexual abuse of a ward second degree': 8,
    'Unlawful possession of a firearm': 8,

    // Group 9 Offenses
    'Issuing a bad check': 9,
    'Violation of Bail Reform Act': 9,
    'Blackmail': 9,
    'Credit card fraud': 9,
    'Escape from custody': 9,
    'False personation of a police officer': 9,
    'Forgery': 9,
    'Fraud first degree': 9,
    'Fraud second degree': 9,
    'Impersonating a public official': 9,
    'Introducing Class B contraband into a penal institution': 9,
    'Possession of Prohibited Weapon -- second or more offense': 9,
    'Receiving Stolen Property': 9,
    'Breaking and Entering a vending machine': 9,
    'Uttering (passing forged documents)': 9,
    'Attempted enticing of a child': 9,
    'Attempted sexual abuse fourth degree': 9,
    'Attempted sexual abuse of a patient second degree': 9,
    'Attempted sexual abuse of a ward second degree': 9,
    'Theft second degree (if two or more theft convictions)': 9,
  };
  
  export const offenseToSeverityGroup = {
    //"Accessory After the Fact": 1,
    //"Aiding & Abetting": 1,
    "Aggravated Assault w/a": 4,
    "Aggravated Assault": 6,
    "Aggravated Assault -- Attempt": 8,
    //"Aggravating Circumstances": 1,
    "Animal Fighting, Engaging in": 9,
    "Armor Piercing Ammunition": 7,
    "Arson": 6,
    "Arson -- Own property w/ intent to defraud": 6,
    "Assault with a Dangerous Weapon (ADW)": 6,
    "Assault with a Dangerous Weapon (ADW) -- Attempt": 8,
    "Assault on Police Officer (APO) w/a": 5,
    "Assault on Police Officer (APO)": 7,
    "Assault on Police Officer (APO) w/ deadly weapon -- 2nd offense or prior felony": 7,
    "Assault with Intent to Kill or Poison w/a": 3,
    "Assault with Intent to Kill or Poison": 5,
    "Assault with Intent to Rob w/a": 5,
    "Assault with Intent to Rob": 6,
    "Assault with Intent to 1º or 2º Sexual Abuse or Child Sex Abuse w/a": 6,
    "Assault with Intent to 1º or 2º Sexual Abuse or Child Sex Abuse": 5,
    "Assault with Intent to Commit any other Felony w/a": 5,
    "Assault with Intent to Commit any other Felony": 8,
    "Assault with Intent to Commit Mayhem w/a": 5,
    "Assault with Intent to Commit Mayhem": 7,
    "Assault with Significant Bodily Injury": 8,
    "Assault with Significant Bodily Injury w/a": 6,
    "Attempt Crime of Violence w/a": 1, // Invalid
    "Attempt Crime of Violence unarmed": 8,
    "Bad Checks $1000+": 9,
    "Bail Reform Act (BRA) violation": 9,
    "Bias-Related Crime": 1, // invalid
    "Bigamy": 8,
    "Blackmail with threats of violence w/a": 8,
    "Blackmail": 9,
    "Breaking and Entering -- Vending Machines": 9,
    "Bribery -- Public Servant": 8,
    "Bribery -- Witness": 8,
    "Burglary I w/a": 3,
    "Burglary I": 5,
    "Burglary II w/a": 6,
    "Burglary II": 7,
    "Carjacking w/a": 3,
    "Carjacking": 5,
    "Carrying a Pistol – Felony (CPWL) Carrying Dangerous Weapon – Felony (CDW) 1st offense": 8,
    "Carrying a Pistol – Felony (CPWL) Carrying Dangerous Weapon – Felony (CDW) 2nd + offense or after felony conviction": 8,
    "Child Prostitution – Abducting/Enticing": 5,
    "Child Prostitution -- Harboring": 5,
    "Child Sex Abuse -- Aggravated 1º": 3,
    "Child Sex Abuse -- 1º w/a": 2,
    "Child Sex Abuse -- 1º": 3,
    "Child Sex Abuse -- Attempt 1º w/a": 5,
    "Child Sex Abuse -- Attempt 1º": 6,
    "Child Sex Abuse, Assault with Intent to Commit -- 1º or 2º": 6,
    "Child Sex Abuse -- 2º w/a": 5,
    "Child Sex Abuse -- 2º": 6,
    "Child Sex Abuse -- Attempt 2º w/a": 5,
    "Child Sex Abuse -- Attempt 2º": 8,
    "Child Sex Abuse -- Enticing": 8,
    "Child Sex Abuse -- Enticing -- Attempt": 9,
    "Child Sex Abuse -- Arranging for Sexual Contact": 8,
    "Child Sex Abuse -- Arranging for Sexual Contact -- Attempt": 9,
    "Citizen Patrol Victim": 1, // invalid
    "Conspiracy in general": 9,
    "Conspiracy to Commit Murder or an Armed COV": 5,
    "Conspiracy to Commit COV": 7,
    "Contempt for violating conditions of release, if felony": 9,
    "Contraband -- Introducing into prison and possession by inmate: Class A material": 8,
    "Contraband -- Introducing into prison and possession by inmate: Class B material": 9,
    "Contributing to the Delinquency of a Minor: 2nd + offense": 9,
    "Contributing to the Delinquency of a Minor: Commission of felony, serious bodily injury": 8,
    "Contributing to the Delinquency of a Minor: Death": 6,
    "Corrupt Influence": 9,
    "Corrupt Influence -- Athletics": 9,
    "Counterfeiting -- 2nd offense or value $1,000 to 10,000 or 100 - 1,000 items": 9,
    "Counterfeiting -- 3+ offense or value > $10,000 or 1,000 items": 9,
    "Credit Card Fraud -- $1,000+": 9,
    "Crime of Violence Against Minors": 1, // invalid
    "Criminal Abuse or Neglect of a Vulnerable Adult -- Death": 5,
    "Criminal Abuse or Neglect of a Vulnerable Adult -- Permanent bodily harm": 6,
    "Criminal Abuse or Neglect of a Vulnerable Adult -- Serious bodily injury/severe mental distress": 7,
    "Cruelty to Animals": 9,
    "Cruelty to Children -- 1º w/a": 5,
    "Cruelty to Children -- 1º": 6,
    "Cruelty to Children -- 2º": 8,
    "Deceptive Labeling": 9,
    "Destruction of Property (DP) -- $1,000+": 8,
    "Destruction of Property (DP) -- explosives": 8,
    // Drug groups
    "Drugs -- Distribution, or PWID w/a (any drug)": 1,
    "Drugs -- Distribution, or PWID: I, II Narcotic and abusive drugs (heroin, cocaine, PCP, methamphetamine, etc.)": 2,
    "Drugs -- Distribution, or PWID: I, II, III Non-narcotic and non-abusive drugs (including marijuana -- 2nd offense or > ½ pound)": 3,
    "Drugs -- Distribution, or PWID: IV": 3,
    "Drugs -- Possession of Liquid PCP": 3,
    "Drugs -- Attempt or Conspiracy of a while armed offense in Drug Group 1": 2,
    "Drugs -- Attempt or Conspiracy of an offense in Drug Group 2": 3,
    "Drugs -- Attempt or Conspiracy of an offense in Drug Group 3": 4,
    "Drugs -- Distribution to Minors": 1,  // invalid
    "Drugs -- Enlisting Minors -- 1st offense": 1,  // invalid
    "Drugs -- Enlisting Minors -- 2nd + offense": 1,  // invalid
    "Drugs -- Fraud": 3,
    "Drug-Free Zones": 1,  // invaild
    "Drugs -- Maintaining place for": 2,
    "Drugs -- 2nd+ offense": 1,
    // end of drug group
    "Drug Paraphernalia, 2nd + offense": 9,
    "Drug Paraphernalia -- Distributing to a Minor": 3, // Drug group
    "Escape, and Attempt Escape": 9,
    "Extortion with threats of violence w/a": 8,
    "Extortion": 8,
    "False Personation": 9,
    "False Statement (Money Transmissions)": 9,
    "False Swearing": 9,
    "Felony Assault": 8,
    "Felony Assault w/a": 6,
    "Financial Exploitation of a Vulnerable Adult or Elderly Person -- $1000 or More": 8,
    "Financial Exploitation of a Vulnerable Adult or Elderly Person -- 2+ Prior Convictions": 8,
    "Firearm, Unlawful Possession of by a person with a prior conviction > 1 yr": 8,
    "Firearm, Unlawful Possession of by a person with a prior conviction > 1 yr and COV other than Conspiracy": 7,
    "Firearm, Unlawful Possession of by others": 8,
    "Fleeing Law Enforcement": 8,
    "Forgery and Uttering: Legal tender": 9,
    "Forgery and Uttering: Token": 9,
    "Forgery and Uttering: Other": 9,
    "Fraud -- 1º -- $1,000+": 9,
    "Fraud -- 2º -- $1,000+": 9,
    "Gaming": 9,
    "Gang Recruitment w/a": 5,
    "Gang Recruitment, Retaliation or Participation": 7,
    "Gang Participation": 8,
    "Government Officials, Intimidating, Impeding, Interfering, Retaliating": 8,
    "Government Officials/Family, Stalking, Threatening, Assaulting, Kidnapping, Injuring or Vandalizing, Damaging, Destroying or Taking Property of": 9,
    "Grave Robbing": 9,
    "Gun-Free Zone": 1, // invalid
    "Human Trafficking -- Forced Labor": 5,
    "Human Trafficking -- Forced Labor -- Attempt": 7,
    "Human Trafficking -- Labor or Commercial Sex Acts": 5,
    "Human Trafficking -- Labor or Commercial Sex Acts -- Attempt": 7,
    "Human Trafficking -- Sex Trafficking of Children": 5,
    "Human Trafficking -- Sex Trafficking of Children -- Attempt": 7,
    "Human Trafficking -- Documents": 8,
    "Human Trafficking -- Documents -- Attempt": 9,
    /* invalid
    "Human Trafficking -- Benefitting Financially": 1,
    "Human Trafficking -- Benefitting Financially -- Attempt": 1,
    "Human Trafficking -- Victim held/services provided >180 days": 1,
    */
    "Identity Theft -- 1º": 8,
    "Identity Theft -- 1º against senior citizen": 8,
    "Illegal Dumping (commercial)": 9,
    "Illegal Lottery": 9,
    "Impersonating a Public Official": 9,
    "Incest": 7,
    "Injure/Obstruct a Police Animal - Significant Bodily Injury/Death": 8,
    "Insurance Fraud -- 1º -- $1,000+": 9,
    "Insurance Fraud -- 2º -- $1,000+ 1st offense": 9,
    "Insurance Fraud -- 2º -- $1,000+ 2nd offense": 9,
    "Interception, Disclosure, and Use of Wire or Oral Communications": 9,
    "Kidnapping w/a": 3,
    "Kidnapping": 5,
    "Malicious Disfigurement w/a": 5,
    "Malicious Disfigurement": 6,
    "Manslaughter -- Voluntary -- w/a": 3,
    "Manslaughter -- Voluntary": 4,
    "Manslaughter -- Involuntary -- w/a": 5,
    "Manslaughter -- Involuntary": 5,
    "Mayhem w/a": 5,
    "Mayhem": 6,
    "Molotov Cocktails -- 1st offense": 9,
    "Molotov Cocktails -- 2nd offense": 9,
    "Molotov Cocktails -- 3rd offense": 9,
    "Money Transmission Without a License": 9,
    "Aggravated Murder I": 1,
    "Murder I w/a": 1,
    "Murder I": 1,
    "Murder I -- Obstruction of Railway": 1,
    "Murder II w/a": 2,
    "Murder II": 2,
    "Murder of P.O.": 1,
    "Negligent Homicide (Vehicular)": 7,
    "Obscenity -- 2nd+ offense": 9,
    "Obstructing Justice": 5,
    "Obstructing Railways": 9,
    "Obstructing Service of a Drug Search Warrant": 9,
    "Offenses Committed During Release (felony)": 9,
    "Offenses not covered by D.C. Code": 9,
    "Possession of Drug Paraphernalia (PDP) w/ Intent -- 2nd+ offense": 9,
    "Perjury": 8,
    "Perjury, Subornation of": 8,
    "Possession of a Firearm During a Crime of Violence or Dangerous Crime (PFCOV)": 5,
    "Possession of Implements of Crime -- 2nd+ offense or after felony": 9,
    "Possession of a Large Capacity Ammunition Feeding Device": 9,
    "Possession of Prohibited Weapon (PPW) -- 2nd+ offense or after felony": 9,
    "Possession of Unregistered Weapon -- 2nd offense": 9,
    "Prostitution, Engaging In or Soliciting -- 3+ offense": 9,
    "Prostitution -- Inducing or Compelling": 9,
    "Prostitution -- Inducing or Compelling a Minor": 5,
    "Prostitution -- Against Will": 6,
    "Prostitution -- Against Will a Minor": 5,
    "Prostitution -- Procuring (pandering)": 9,
    "Prostitution -- Procuring (pandering) a Minor": 5,
    "Prostitution, Causing Spouse to Live In": 8,
    "Prostitution -- Detaining in Disorderly House for Debt": 9,
    "Prostitution, Procuring for House of": 9,
    "Prostitution, Procuring for 3rd Persons": 9,
    "Prostitution, Operating House of": 9,
    "Prostitution -- Keeping Bawdy or Disorderly House": 9,
    "Receiving Stolen Property (RSP) -- $1,000+": 9,
    "Repeats -- 1 prior": 1, // invalid
    "Repeats -- 2+ priors": 1, // invalid
    "Riot, Inciting (felony)": 7,
    "Robbery -- w/a": 5,
    "Robbery": 6,
    "Robbery -- Attempt w/a": 6,
    "Robbery -- Attempt": 8,
    "Sell, Transport, Distribute a Firearm, Destructive Device or Ammunition to Persons Under 18": 1,
    "Senior Citizen Victim": 7,
    "Sex Abuse -- Aggravated 1º": 2,
    "Sex Abuse -- 1º w/a": 2,
    "Sex Abuse -- 1º": 2,
    "Sex Abuse -- Attempt 1º w/a": 5,
    "Sex Abuse -- Attempt 1º": 6,
    "Sex Abuse -- Aggravated other than 1º": 1,  // invalid
    "Sex Abuse -- 2º w/a": 4,
    "Sex Abuse -- 2º": 5,
    "Sex Abuse -- Attempt 2º w/a": 4,
    "Sex Abuse -- Attempt 2º": 5,
    "Sex Abuse -- 3º w/a": 5,
    "Sex Abuse -- 3º": 7,
    "Sex Abuse -- Attempt 3º": 8,
    "Sex Abuse -- 4º": 8,
    "Sex Abuse -- Attempt 4º": 9,
    "Sex Abuse of a Minor -- 1º": 6,
    "Sex Abuse of a Minor -- Attempt 1º": 7,
    "Sex Abuse of a Minor -- 2º": 7,
    "Sex Abuse of a Minor -- Attempt 2º": 9,
    "Sex Abuse of a Minor -- Enticing": 8,
    "Sex Abuse of a Minor -- Enticing -- Attempt": 9,
    "Sex Abuse of a Student -- 1º": 7,
    "Sex Abuse of a Student -- Attempt 1º": 8,
    "Sex Abuse of a Student -- 2º": 8,
    "Sex Abuse of a Student -- Attempt 2º": 9,
    "Sex Abuse -- Patient 1º": 7,
    "Sex Abuse -- Patient -- Attempt 1º": 8,
    "Sex Abuse -- Patient -- 2º": 8,
    "Sex Abuse -- Patient -- Attempt 2º": 9,
    "Sex Abuse -- Ward -- 1º": 7,
    "Sex Abuse -- Ward -- Attempt 1º": 8,
    "Sex Abuse -- Ward -- 2º": 8,
    "Sex Abuse -- Ward -- Attempt 2º": 9,
    "Sex Offender -- Failure to Register -- 2nd offense": 9,
    "Sex Performance w/ Minors -- 1st offense": 8,
    "Sex Performance w/ Minors -- 2nd + offense": 8,
    "Solicitation of Murder": 4,
    "Solicitation of Other Crime of Violence": 6,
    "Stalking - Felony": 9,
    "Stalking - Felony: if two or more qualifying convictions": 9,
    "Tampering with Physical Evidence": 9,
    "Tampering with a VIN -- $1,000+": 9,
    "Tax - Attempt to Evade or Defeat -- $10,000+": 9,
    "Terrorism - Murder I – LEO -- Attempt/Conspire": 3,
    "Terrorism - Murder I w/a – LEO -- Attempt/Conspire": 2,
    "Terrorism - Murder II": 2,
    "Terrorism - Murder II w/a": 2,
    "Terrorism - Manslaughter": 4,
    "Terrorism - Manslaughter w/a": 3,
    "Terrorism - Kidnapping": 4,
    "Terrorism - Kidnapping w/a": 3,
    "Terrorism - Kidnapping -- Attempt/Conspire": 5,
    "Terrorism - Kidnapping w/a -- Attempt/Conspire": 4,
    "Terrorism - AWIK": 4,
    "Terrorism - AWIK w/a": 3,
    "Terrorism - Mayhem/Malicious Disfig.": 5,
    "Terrorism - Mayhem/Malicious Disfig. w/a": 4,
    "Terrorism - Mayhem/Malicious Disfig. Attempt/Conspire": 6,
    "Terrorism - Mayhem/Malicious Disfig. w/a Attempt/Conspire": 5,
    "Terrorism - Arson": 5,
    "Terrorism  Arson w/a": 4,
    "Terrorism - Arson -- Attempt/Conspire": 6,
    "Terrorism - Arson w/a -- Attempt/Conspire": 5,
    "Terrorism - Destruction of Prop.": 5,
    "Terrorism - Destruction of Prop. w/a": 4,
    "Terrorism - Destruction of Prop. -- Attempt/Conspire": 6,
    "Terrorism - Destruction of Prop. w/a -- Attempt/Conspire": 5,
    "Terrorism - Material Support": 5,
    "Terrorism - Material Support w/a": 4,
    "Terrorism - Soliciting": 6,
    "Terrorism - Soliciting w/a": 5,
    "Theft -- 1º if two or more theft convictions": 8,
    "Theft -- 2º if two or more theft convictions": 9,
    "Threats -- Felony": 8,
    "Three Strikes for Felonies": 1, // invalid
    "Three Strikes for Violent Felonies": 1,  // invalid 
    "Trafficking in Stolen Property": 8,
    "Unlawful Possession of a Firearm: prior convictions > 1 yr and COV other than Conspiracy": 7,
    "Unlawful Possession of a Firearm: prior conviction > 1 yr": 8,
    "Unlawful Possession of a Firearm: others": 8, // ???
    "Unlawful Publication -- 1º (Revenge Pornography)": 9,
    "Unauthorized Use of a Motor Vehicle (UUV) -- Private": 8,
    "Unauthorized Use of a Motor Vehicle (UUV) -- Private Two or more UUV or Theft 1º convictions": 8,
    "Unauthorized Use of a Motor Vehicle (UUV) -- Private During or to facilitate COV": 7,
    "Unauthorized Use of a Motor Vehicle (UUV) -- Private During or to facilitate COV w/ serious bodily injury": 7,
    "Unauthorized Use of a Motor Vehicle (UUV) -- Rental": 8,
    "Voyeurism – Distribution": 8,
    "Water Pollution -- Malicious": 9,
};


/*
Drugs -- Possession of Liquid PCP 48-904.01(d)(2) D 3 3 1 2 3 12,500
Drugs -- Attempt or Conspiracy of a while armed offense in
Drug Group 1
48-904.09 D 2 same
term as
complete
d offense
same fine
Drugs -- Attempt or Conspiracy of an offense in Drug
Group 2
48-904.09 D 3 same
term as
complete
d offense
same fine
Drugs -- Attempt or Conspiracy of an offense in Drug
Group 3
48-904.09 D 4 same
term as
complete
d offense
same fine
Drugs -- Distribution to Minors 48-904.06 2 x the
term
same fine
Drugs -- Enlisting Minors -- 1st offense 48-904.07(b)(1) 50 10 2 8 3 25,000
Drugs -- Enlisting Minors -- 2nd + offense 48-904.07(b)(2) 51 20 2 18 3 50,000
Drugs -- Fraud 48-904.03 D 3 4 1 3 3 12,500
Drug-Free Zones 48-904.07a 2 x the
term
2x the fine
Drugs -- Maintaining place for 48-904.03a D 2 25 3 22 3 not < 5 75,000
Drugs -- 2nd+ offense 48-904.08 2 x the
term
2 x the fine
Drug Paraphernalia, 2nd + offense 48-1103(e)(4) M 9 2 1 1 3 12,500

Drug Paraphernalia -- Distributing to a Minor 48-1103(c) D 3 8 2 6 3 25,000
Escape, and Attempt Escape 22-2601 M 9 5 2 3 3 12,500
Extortion with threats of violence w/a* 22-3251
22-4502
M 8 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 52 75,000
Extortion 22-3251 M 8 10 2 8 3 V 53 25,000
False Personation 22-1403 M 9 5 2 3 3 not < 1 12,500
False Statement (Money Transmissions) 26-1023(b) M 9 3 1 2 3 12,500
False Swearing 22-2404 M 9 3 1 2 3 12,500
Felony Assault 22-404(a)(2) M 8 3 1 2 3 V 12,500
Felony Assault w/a* 22-404(a)(2)
22-4502
M 6 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Financial Exploitation of a Vulnerable Adult or Elderly
Person -- $1000 or More
22-933.01
22-936.01(a)(1)
M 8 10 2 8 3 25,000
Financial Exploitation of a Vulnerable Adult or Elderly
Person -- 2+ Prior Convictions
22-933.01
22-936.01(b)
M 8 15 2 13 3 37,500
Firearm, Unlawful Possession of by a person with a prior
conviction > 1 yr
22-4503(a)(1) M 8 54 10 2 8 3 M1 25,000
Firearm, Unlawful Possession of by a person with a prior
conviction > 1 yr and COV other than Conspiracy
22-4503(a)(1) M 7 15 2 13 3 M3 37,500

Firearm, Unlawful Possession of by others 22-4503(a)(2) – (a)(6) M 8 10 2 8 3 not < 2 25,000
Fleeing Law Enforcement 50-2201.05b(b)(2) M 8 5 2 3 3 12,500
Forgery and Uttering:
Legal tender
22-3241
22-3242(a)
M 9 10 2 8 3 25,000
Forgery and Uttering:
Token
22-3241
22-3242(b)
M 9 5 2 3 3 12,500
Forgery and Uttering:
Other
22-3241
22-3242(c) M 9 3 1 2 3 12,500
Fraud -- 1º -- $1,000+ 22-3221(a)
22-3222(a)(1) M 9 10 2 8 3 25,000/ 2x the
value
Fraud -- 2º -- $1,000+ 22-3221(b)
22-3222(b)(1) M 9 3 1 2 3 12,500/ 2x the
value
Gaming 22-1704 M 9 5 2 3 3 12,500
Gang Recruitment w/a* 22-951(c)
22-4502
M 5 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Gang Recruitment, Retaliation or Participation 22-951(c) M 7 10 2 8 3 V 25,000
Gang Participation 22-951(b) M 8 5 2 3 3 12,500
Government Officials, Intimidating, Impeding, Interfering,
Retaliating
22-851(b) M 8 5 2 3 3 12,500
Government Officials/Family, Stalking, Threatening,
Assaulting, Kidnapping, Injuring or Vandalizing,
Damaging, Destroying or Taking Property of
22-851(c), (d) M 9 3 1 2 3 12,500
Grave Robbing 22-3303 M 9 3 1 2 3 not < 1 12,500
Gun-Free Zone 22-4502.01 2 x the
term
2x the fine
  


-----
Human Trafficking -- Forced Labor 22-1832
22-1837
M 5 20 2 18 3 50,000
Human Trafficking -- Forced Labor -- Attempt 22-1832
22-1837
M 7 10 2 8 3 25,000
Human Trafficking -- Labor or Commercial Sex Acts 22-1833
22-1837
M 5 20 2 18 3 50,000
Human Trafficking -- Labor or Commercial Sex Acts --
Attempt
22-1833
22-1837 M 7 10 2 8 3 25,000
Human Trafficking -- Sex Trafficking of Children 22-1834
22-1837 M 5 20 2 18 3 50,000
Human Trafficking -- Sex Trafficking of Children -- Attempt 22-1834
22-1837 M 7 10 2 8 3 25,000
Human Trafficking -- Documents 22-1835
22-1837 M 8 5 2 3 3 12,500
Human Trafficking -- Documents -- Attempt 22-1835
22-1837 M 9 2½ 1 1½ 3 12,500
Human Trafficking -- Benefitting Financially 22-1836
22-1837 Same as
principal
Same as
principal
Human Trafficking -- Benefitting Financially -- Attempt 22-1836
22-1837 Same as
principal
attempt
Same as
principal
attempt
Human Trafficking -- Victim held/services provided >180 days 22-1837 1 ½ x the
term
1 ½ x the fine
Identity Theft -- 1º 22-3227.02
22-3227.03(a) M 8 10 2 8 3 25,000 or 2x
the value/injur


dentity Theft -- 1º against senior citizen 22-3227.02
22-3227.03(c)
M 8e 15 2 13 3 1 ½ x the fine
Illegal Dumping (commercial) 8-902(b)(2) M 9 5 2 3 3 12,500
Illegal Lottery 22-1701 M 9 3 1 2 3 12,500
Impersonating a Public Official 22-1404 M 9 3 1 2 3 not < 1 12,500
Incest 22-1901 M 7 12 2 10 3 37,500
Injure/Obstruct a Police Animal - Significant Bodily
Injury/Death
22-861(b)(2) M8 10 2 8 3 25,000
Insurance Fraud -- 1º -- $1,000+ 22-3225.02
22-3225.04(a) M 9 15 2 13 3 37,500
Insurance Fraud -- 2º -- $1,000+ 1st offense 22-3225.03
22-3225.04(b)(1) M 9 5 2 3 3 12,500
Insurance Fraud -- 2º -- $1,000+
2nd offense
22-3225.03
22-3225.04(b)(2)
M 9e 10 2 8 3 25,000
Interception, Disclosure, and Use of Wire or Oral
Communications
23-542 M9 5 2 3 3 12,500
Kidnapping w/a* 22-2001
22-4502
M 3 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Kidnapping* 22-2001 M 5 30 5 30 5 V 75,000
Malicious Disfigurement w/a* 22-406
22-4502
M 5 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Malicious Disfigurement 22-406 M 6 10 2 8 3 V 25,000
Manslaughter -- Voluntary -- w/a* 22-2105
22-4502
M 3 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 250,000

Manslaughter -- Voluntary 22-2105 M 4 30 3 27 5 V 250,000
Manslaughter -- Involuntary -- w/a* 22-2105
22-4502 M 5 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 250,000
Manslaughter -- Involuntary 22-2105 M 5 30 3 27 5 V 250,000
Mayhem w/a* 22-406
22-4502 M 5 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Mayhem 22-406 M 6 10 2 8 3 V 25,000
Molotov Cocktails -- 1st offense 22-4515a M 9 5 2 3 3 not < 1 12,500
Molotov Cocktails -- 2nd offense 22-4515a M 9e 15 2 13 3 not < 3 37,500
Molotov Cocktails -- 3rd* offense* 22-4515a M 9e 30 5 30 5 not < 5 75,000
Money Transmission Without a License 26-1023(c) M 9 5 2 3 3 12,500
Aggravated Murder I* 22-2104
22-2104.01
24-403.01(b-2)
M 1e LWOR 5 LWOR 5 V 250,000
Murder I w/a* 22-2101
22-2104
22-4502
M 1 LWOR
(60)
5 LWOR 5 M30 V 250,000
Murder I* 22-2101
22-2104
24-403.01(b-2)
M 1 LWOR
(60)
5 LWOR 5 M30 V 250,000
Murder I -- Obstruction of Railway* 22-2102
22-2104
24-403.01(b-2)
M 1 LWOR
(60)
5 LWOR 5 M30 V 250,000
Murder II w/a* 22-2103
22-2104
22-4502
M 2 Life (40) 5 Life 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 250,000


Murder II* 22-2103
22-2104
24-403.01(b-2)
M 2 Life
(40)
5 Life 5 V 250,000
Murder of P.O.* 22-2106 M 1 LWOR LWOR M-LWOR V 250,000
Negligent Homicide (Vehicular) 50-2203.01 M 7 5 2 3 3 250,000
Obscenity -- 2nd+ offense 22-2201(e) M 9 3 1 2 3 not < 6 months 1,000 - 12,500
Obstructing Justice* 22-722 M 5 30 5 30 5 not < 3 75,000
Obstructing Railways 22-3319 M 9 10 2 8 3 25,000
Obstructing Service of a Drug Search Warrant 48-921.02(n) M 9 2 1 1 3 12,500
Offenses Committed During Release (felony) 55 23-1328(a)(1) M 9 56 5 Not < 1 12,500
Offenses not covered by D.C. Code 22-1807 M 9 5 2 3 3 12,500
Possession of Drug Paraphernalia (PDP) w/ Intent -- 2nd+
offense
48-1103(b) M 9 2 1 1 3 12,500
Perjury 22-2402 M 8 10 2 8 3 25,000
Perjury, Subornation of 22-2403 M 8 10 2 8 3 25,000
Possession of a Firearm During a Crime of Violence or
Dangerous Crime (PFCOV)
22-4504(b) M 5 15 2 13 3 M5 37,5

----
Possession of Implements of Crime -- 2nd
+ offense or after
felony
22-2501
24-403.01(f)(3)
M 9 5 2 3 3 not < 1 12,500
Possession of a Large Capacity Ammunition Feeding
Device
7-2507.06(a)(4) M 9 3 1 2 3 12,500
Possession of Prohibited Weapon (PPW) -- 2nd+ offense
or after felony
22-4514 M 9 10 2 8 3 25,000
Possession of Unregistered Weapon -- 2nd offense 7-2502.01
7-2507.06(a)(2)(A) M 9 5 2 3 3 12,500
Prostitution, Engaging In or Soliciting -- 3+ offense 22-2701 M 9 2 1 1 3 12,500
Prostitution -- Inducing or Compelling 22-2705(c)(1) M 9 5 2 3 3 12,500
Prostitution -- Inducing or Compelling a Minor 22-2705(c)(2) M 5 20 2 18 3 or SOR 50,000
Prostitution -- Against Will 22-2706(b)(1) M 6 15 2 13 3 37,500
Prostitution -- Against Will a Minor 22-2706(b)(2) M 5 20 2 18 3 or SOR 50,000
Prostitution -- Procuring (pandering) 22-2707(b)(1) M 9 5 2 3 3 12,500
Prostitution -- Procuring (pandering) a Minor 22-2707(b)(2) M 5 20 2 18 3 or SOR 50,000
Prostitution, Causing Spouse to Live In 22-2708 M 8 10 2 8 3 not < 1 25,000
Prostitution -- Detaining in Disorderly House for Debt 22-2709 M 9 5 2 3 3 not < 1 12,500
Prostitution, Procuring for House of 22-2710 M 9 5 2 3 3 12,500

Prostitution, Procuring for 3rd Persons 22-2711 M 9 5 2 3 3 12,500
Prostitution, Operating House of 22-2712 M 9 5 2 3 3 12,500
Prostitution -- Keeping Bawdy or Disorderly House 22-2722 M 9 5 2 3 3 12,500
Receiving Stolen Property (RSP) -- $1,000+ 22-3232(c)(1) M 9 7 2 5 3 25,000
Repeats -- 1 prior 22-1804 1½ x the
term
1½ x the fine
Repeats -- 2+ priors 22-1804 3 x the
term
3 x the fine
Riot, Inciting (felony) 22-1322(d) M 7 10 2 8 3 25,000
Robbery -- w/a* 22-2801
22-4502 M 5 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
not < 2 57
V 75,000
Robbery 22-2801 M 6 15 2 13 3 not < 2 V 37,500
Robbery -- Attempt w/a* 22-2802
22-4502 M 6 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Robbery -- Attempt 22-2802 M 8 3 1 2 3 V 12,500
Sell, Transport, Distribute a Firearm, Destructive Device or
Ammunition to Persons Under 18
7-2507.06(1) M 7 10 2 8 3 25,000
Senior Citizen Victim 22-3601 1½ x
the
term
1 ½ x the fine
Sex Abuse -- Aggravated 1º* 22-3002
22-3020
M 2e LWOR 5 LWOR 5 or SOR V 125,000


Sex Abuse -- 1º w/a* 22-3002
22-4502
M 2 LWOR
(30)
5 LWOR
(30)
5 or SOR M5 1st firearm
M10 2nd firearm
M5 2nd other
V 125,000
(75,000)
Sex Abuse -- 1º* 22-3002
24-403.01(e) M 2 LWOR
(30)
5 LWOR
(30)
5 or SOR not < 7 if prior
COV V 125,000
(75,000)
Sex Abuse -- Attempt 1º w/a* 22-3002
22-3018
22-4502
M 5 30 5 30 5 or SOR M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Sex Abuse -- Attempt 1º 22-3002
22-3018 M 6 15 2 13 3 or SOR V 37,500
Sex Abuse -- Aggravated other than 1º 22-3020 1½ x
the term 1½ x the fine
Sex Abuse -- 2º w/a* 22-3003
22-4502 M 4 30 5 30 5 or SOR M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Sex Abuse -- 2º 22-3003
24-403.01(e) M 5 20 2 18 3 or SOR not < 7 if prior
COV V 50,000
Sex Abuse -- Attempt 2º w/a* 22-3003
22-3018
22-4502
M 5 30 5 30 5 or SOR M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Sex Abuse -- Attempt 2º 22-3003
22-3018
M 7 10 2 8 3 or SOR V 25,000
Sex Abuse -- 3º w/a* 22-3004
22-4502 M 5 30 5 30 5 or SOR M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Sex Abuse -- 3º 22-3004 M 7 10 2 8 3 or SOR V 25,000
Sex Abuse -- Attempt 3º 22-3004
22-3018
M 8 5 2 3 3 or SOR V 12,500

Sex Abuse -- 4º 22-3005 M 8 5 2 3 3 or SOR 12,500
Sex Abuse -- Attempt 4º 22-3005
22-3018 M 9 2½ 1 1½ 3 or SOR 12,500
Sex Abuse of a Minor -- 1º 22-3009.01 M 6 15 2 13 3 or SOR 37,500
Sex Abuse of a Minor -- Attempt 1º 22-3009.01
22-3018 M 7 7½ 2 5½ 3 or SOR 25,000
Sex Abuse of a Minor -- 2º 22-3009.02 M 7 7½ 2 5½ 3 or SOR 25,000
Sex Abuse of a Minor -- Attempt 2º 22-3009.02
22-3018 M 9 3¾ 1 2¾ 3 or SOR 12,500
Sex Abuse of a Minor -- Enticing 22-3010(a), (b)
24-403.01(e) M 8 5 2 3 3 or SOR not < 7 if prior COV 12,500
Sex Abuse of a Minor -- Enticing -- Attempt 22-3010
22-3018 M 9 2½ 1 1½ 3 or SOR 12,500
Sex Abuse of a Student -- 1º 22-3009.03 M 7 10 2 8 3 or SOR 25,000
Sex Abuse of a Student -- Attempt 1º 22-3009.03
22-3018 M 8 5 2 3 3 or SOR 12,500
Sex Abuse of a Student -- 2º 22-3009.04 M 8 5 2 3 3 or SOR 12,500
Sex Abuse of a Student -- Attempt 2º 22-3009.04
22-3018 M 9 2½ 1 1½ 3 or SOR 12,500
Sex Abuse -- Patient 1º 22-3015 M 7 10 2 8 3 or SOR 25,000
Sex Abuse -- Patient -- Attempt 1º 22-3015
22-3018 M 8 5 2 3 3 or SOR 12,500
Sex Abuse -- Patient -- 2º 22-3016 M 8 5 2 3 3 or SOR 12,500
Sex Abuse -- Patient -- Attempt 2º 22-3016
22-3018 M 9 2½ 1 1½ 3 or SOR 12,500
Sex Abuse -- Ward -- 1º 22-3013 M 7 10 2 8 3 or SOR 25,000
Sex Abuse -- Ward -- Attempt 1º 22-3013
22-3018 M 8 5 2 3 3 or SOR 12,500

Sex Abuse -- Ward -- 2º 22-3014 M 8 5 2 3 3 or SOR 12,500
Sex Abuse -- Ward -- Attempt 2º 22-3014
22-3018
M 9 2½ 1 1½ 3 or SOR 12,500
Sex Offender -- Failure to Register -- 2nd offense 22-4015(a) M 9 5 2 3 3 12,500
Sex Performance w/ Minors -- 1st offense 22-3102
22-3103(1) M 8 10 2 8 3 or SOR 25,000
Sex Performance w/ Minors -- 2nd + offense
22-3102
22-3103(2) M 8e 20 2 18 3 or SOR 50,000
Solicitation of Murder 22-2107(a) M 4 20 2 18 3 50,000
Solicitation of Other Crime of Violence 22-2107(b) M 6 10 2 8 3 25,000
Stalking - Felony 22-3133
22-3134(b) M 9 5 2 3 3 12,500
Stalking - Felony: if two or more qualifying convictions 22-3133
22-3134(c) M 9e 10 2 8 3 25,000
Tampering with Physical Evidence 22-723 M 9 3 1 2 3 12,500
Tampering with a VIN -- $1,000+ 22-3233(b)(2) M 9 5 2 3 3 12,500
Tax – Attempt to Evade or Defeat -- $10,000+ 47-4101(a) M 9 10 2 8 3 25,000 or 2x
amount
evaded + cost
of prosecution
*/


/*


Terrorism – Murder I – LEO -- Attempt/Conspire 22-3153(j) M 3 30 3 27 5 V 75,000
Terrorism – Murder I w/a – LEO -- Attempt/Conspire* 22-3153(j)
22-4502 M 2 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Terrorism – Murder II* 22-3153(c) M 2 Life 5 Life 5 V 250,000
Terrorism – Murder II w/a* 22-3153(c)
22-4502 M 2 Life 5 Life 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 250,000
Terrorism – Manslaughter 22-3153(d) M 4 Life 5 Life 5 V 250,000
Terrorism – Manslaughter w/a* 22-3153(d)
22-4502 M 3 Life 5 Life 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 250,000
Terrorism – Kidnapping* 22-3153(e) M 4 Life 5 Life 5 V 125,000
Terrorism – Kidnapping w/a* 22-3153(e)
22-4502 M3 Life 5 Life 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 125,000
Terrorism – Kidnapping -- Attempt/Conspire 22-3153(j) M5 30 3 27 5 V 75,000
Terrorism – Kidnapping w/a -- Attempt/Conspire* 22-3153(j)
22-4502 M 4 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000

Terrorism – AWIK 22-3153(f) M 4 30 3 27 5 V 75,000
Terrorism – AWIK w/a* 22-3153(f)
22-4502
M 3 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Terrorism – Mayhem/Malicious Disfig. 22-3153(g) M 5 20 2 18 3 V 50,000
Terrorism – Mayhem/Malicious Disfig. w/a* 22-3153(g)
22-4502 M 4 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Terrorism – Mayhem/Malicious Disfig. Attempt/Conspire 22-3153(l) M 6 15 2 13 3 V 37,500
Terrorism – Mayhem/Malicious Disfig. w/a*
Attempt/Conspire*
22-3153(l)
22-4502 M 5 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Terrorism – Arson 22-3153(h) M 5 20 2 18 3 V 50,000
Terrorism – Arson w/a* 22-3153(h)
22-4502 M 4 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Terrorism – Arson -- Attempt/Conspire 22-3153(l) M 6 15 2 13 3 V 37,500
Terrorism – Arson w/a -- Attempt/Conspire* 22-3153(l)
22-4502 M 5 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Terrorism – Destruction of Prop. 22-3153(i) M 5 20 2 18 3 V 50,000
Terrorism – Destruction of Prop. w/a* 22-3153(i)
22-4502 M 4 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Terrorism – Destruction of Prop. -- Attempt/Conspire 22-3153(l) M 6 15 2 13 3 V 37,500
Terrorism – Destruction of Prop. w/a -- Attempt/Conspire* 22-3153(l)
22-4502 M 5 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000

Terrorism – Material Support 22-3153(m) M 5 20 2 18 3 V 50,000
Terrorism – Material Support w/a* 22-3153(m)
22-4502 M 4 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Terrorism – Soliciting 22-3153(n) M 6 20 2 18 3 V 50,000
Terrorism – Soliciting w/a* 22-3153(n)
22-4502 M 5 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Theft -- 1º if two or more theft convictions 22-3211
22-3212(c) M 8 15 2 8 3 M1 37,500
Theft -- 2º if two or more theft convictions 22-3211
22-3212(c) M 9 15 2 8 3 M1 37,500
Threats -- Felony 22-1810 M 8 20 2 18 3 50,000
Three Strikes for Felonies* 22-1804a(a)(1) 30 5 30 5 75,000
Three Strikes for Violent Felonies* 22-1804a(a)(2) LWOR 5 LWOR 5 not < 15 125,000
Trafficking in Stolen Property 22-3231 M 8 10 2 8 3 25,000
Unlawful Possession of a Firearm: prior convictions > 1 yr
and COV other than Conspiracy
22-4503(a)(1) M 7 15 2 13 3 M3 37,500

Unlawful Possession of a Firearm: prior conviction > 1 yr 22-4503(a)(1) M 8 58 10 2 8 3 M1 25,000
Terrorism – Material Support w/a* 22-3153(m)
22-4502
M 4 30 5 30 5 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Terrorism – Soliciting 22-3153(n) M 6 20 2 18 3 V 50,000
Terrorism – Soliciting w/a* 22-3153(n)
22-4502
M 5 30 5 30 M5 1st firearm
M10 2nd firearm
M5 2nd other
V 75,000
Theft -- 1º 22-3211
22-3212(a)
M 8 10 2 8 3 25,000
Theft -- 1º if two or more theft convictions 22-3211
22-3212(c)
M 8 15 2 8 3 M1 37,500
Theft -- 2º if two or more theft convictions 22-3211
22-3212(c)
M 9 15 2 8 3 M1 37,500
Threats -- Felony 22-1810 M 8 20 2 18 3 50,000
Three Strikes for Felonies* 22-1804a(a)(1) 30 5 30 5 75,000
Three Strikes for Violent Felonies* 22-1804a(a)(2) LWOR 5 LWOR 5 not < 15 125,000
Trafficking in Stolen Property 22-3231 M 8 10 2 8 3 25,000
Unlawful Possession of a Firearm: prior convictions > 1 yr
and COV other than Conspiracy
22-4503(a)(1) M 7 15 2 13 3 M3 37,500
Unlawful Possession of a Firearm: prior conviction > 1 yr 22-4503(a)(1) M 849 10 2 8 3 M1 25,000
Unlawful Possession of a Firearm: others 22-4503(a)(2) – (a)(6) M 8 10 2 8 3 not < 2 25,000

Unlawful Publication -- 1º (Revenge Pornography) 22-3053 M 9 3 1 2 3 12,500
Unauthorized Use of a Motor Vehicle (UUV) -- Private 22-3215(d)(1) M 8 5 2 3 3 12,500
Unauthorized Use of a Motor Vehicle (UUV) -- Private
Two or more UUV or Theft 1º convictions
22-3215(d)(3) M 8e 15 2 13 3 not < 2½ 5,000 –
37,500
Unauthorized Use of a Motor Vehicle (UUV) -- Private
During or to facilitate COV
22-3215(d)(2) M 7 10 2 8 3 25,000
Unauthorized Use of a Motor Vehicle (UUV) -- Private
During or to facilitate COV w/ serious bodily injury
22-3215(d)(2) M 7 10 2 8 3 not < 5 25,000
Unauthorized Use of a Motor Vehicle (UUV) -- Rental 22-3215(d)(4) M 8 3 1 2 3 12,500
Voyeurism – Distribution 22-3531(f)(2) M 8 5 2 3 3 12,500
Water Pollution -- Malicious 22-3318 M 9 
*/